import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CheckmarkIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
      fill: "#007740"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.3806 6.71474C18.7782 6.40046 19.357 6.43204 19.7176 6.80361C20.0779 7.1751 20.0923 7.75461 19.7664 8.14248L19.6961 8.21767L10.4197 17.2177C10.0318 17.5938 9.41499 17.594 9.02713 17.2177L4.3035 12.6347L4.23416 12.5595C3.90783 12.1716 3.92148 11.5922 4.28201 11.2206C4.64251 10.849 5.22135 10.8174 5.61893 11.1317L5.69607 11.1991L9.72342 15.1063L18.3035 6.78212L18.3806 6.71474Z",
      fill: "white"
    })]
  }));
}